var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImageUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3862_78598",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 41,
    height: 40
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.332031,
    width: 40,
    height: 40,
    fill: "currentColor"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3862_78598)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.66536 35C7.7487 35 6.96398 34.6736 6.3112 34.0208C5.65842 33.3681 5.33203 32.5833 5.33203 31.6667V8.33333C5.33203 7.41667 5.65842 6.63194 6.3112 5.97917C6.96398 5.32639 7.7487 5 8.66536 5H23.6654V8.33333H8.66536V31.6667H31.9987V16.6667H35.332V31.6667C35.332 32.5833 35.0056 33.3681 34.3529 34.0208C33.7001 34.6736 32.9154 35 31.9987 35H8.66536ZM28.6654 15V11.6667H25.332V8.33333H28.6654V5H31.9987V8.33333H35.332V11.6667H31.9987V15H28.6654ZM10.332 28.3333H30.332L24.082 20L19.082 26.6667L15.332 21.6667L10.332 28.3333Z",
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageUpload);
export default __webpack_public_path__ + "static/media/image_upload.666a1a117ff9c11a5994a8fc6d265739.svg";
export { ForwardRef as ReactComponent };